const portfolioData = {
    name: "Shahwar Khan",
    title: "Flutter Developer",
    linkedInLink: "https://www.linkedin.com/in/shahwar-khan-0854b8171/",
    gitHubLink: "https://github.com/shahwarkhan19",
    faceBookLink: "https://facebook.com/usman.mani.9615566",
    instagramLink: "https://www.instagram.com/shahwar_khan19/",
    twitterLink: "https://twitter.com/",
    profileImage: "./assets/me1.png",
    aboutImage: "./assets/me.png",
    aboutDescription: "Hello, I am Flutter developer. I have built several projects for my clients online.  I am confident that my passion for App development and my willingness to learn will make me a valuable addition to any team. I am excited to bring my creativity, problem-solving abilities, and attention to detail to your projects.",
    experience: "0-1 year",
    clients: "10+",
    projects: "20+",
    cv: "./assets/CV.pdf",
    frontendSkills:[
        {
            technology: "HTML",
            level: "Experienced"
        },
        {
            technology: "CSS",
            level: "Experienced"
        },
        {
            technology: "JS",
            level: "Intermediate"
        },
        {
            technology: "Bootstrap",
            level: "Experienced",
        },
        {
            technology: "Kotlin",
            level: "Intermediate",
        },
        {
            technology: "MaterialUi",
            level: "Intermediate",
        },
        {
            technology: "dart",
            level: "Intermediate",
        }
    ],
    backendSkills:[
        {
            technology: "PHP",
            level: "Intermediate",
        },
        {
            technology: "MySql",
            level: "Experienced",
        },
        {
            technology: "java",
            level: "Experienced",
        },
        {
            technology: "python",
            level: "Experienced",
        },
        {
            technology: "Node.js",
            level: "Intermediate",
        }
    ],
    experienceSkills:[
        {
            experienceTitle: 'Frontend Web Developer',
            experienceDuration: 'Nov 2021 - Jan 2022',
            experienceDescription: 'I worked as a freelancer in a freelancing agency, delivered high-quality projects and met client requirements within tight deadlines. I am Proficient in HTML, CSS, JavaScript. Skilled in developing responsive, user-friendly websites and optimizing them for performance and search engines.',
            experienceCompany: 'Freelancing'
        },
        {
            experienceTitle: 'Flutter Developer',
            experienceDuration: 'Jan 2022 - Mar 2022',
            experienceDescription: 'Experienced Flutter developer with a focus on building dynamic user interfaces. Worked on several projects involving Dart and its ecosystem. Skilled in using API and other front-end libraries to implement complex functionalities. Proven ability to work independently and in a team environment to deliver quality software solutions.',
            experienceCompany: 'Social Media'
        }
    ],
    services:[
        {
            serviceTitle: "UI/UX Design",
            serviceLists: ["Interaction Design","User Testing","Prototyping & Wireframing","Visual Design","UI Development","Usability & Accessibility","User Experience Strategy & Consulting"]
        },
        {
            serviceTitle: "Web Development",
            serviceLists: ["HTML/CSS/JS coding","Figma to HTML/CSS","Responsive web design","Performance Optimization","User Interaction & Animation"]
        },
        {
            serviceTitle: "Photoshop Designer",
            serviceLists: ["Social media design","Web design elements","Advertising design.","Visual Design","Image manipulation","Graphic design","Photo retouching"]
        },
        {
            serviceTitle: "App Development",
            serviceLists: ["Applictaion using Flutter","Java/kotlin/xml coding","Responsive app design","User Interaction & Animation","Multi-platform Application","API connection"]
        },
       
    ],
    portfolio:[
        {
            portfolioTitle: "Responsive Portfolio Website Using Html, CSS and JS",
            portfolioImage: "./assets/portfolio-1.png",
            portfolioGithub: "https://github.com/shahwarkhan19/Responsive-Portfolio-Website-Using-Html-CSS-and-JS.git",
            portfolioLive: "https://shahwarkhan19.github.io/Responsive-Portfolio-Website-Using-Html-CSS-and-JS/index.html",
        },
        {
            portfolioTitle: "Tesla Clone Using ReactJs",
            portfolioImage: "./assets/portfolio-6.jpg",
            portfolioGithub: "https://github.com/shahwarkhan19/",
            portfolioLive: "https://tesla-clone-019.netlify.app/",
        },
        {
            portfolioTitle: "Disney Clone Using ReactJs",
            portfolioImage: "./assets/portfolio-7.jpg",
            portfolioGithub: "https://github.com/shahwarkhan19/",
            portfolioLive: "https://disney-clone-019.netlify.app/",
        },
        {
            portfolioTitle: "Responsive Portfolio Website Using ReactJs",
            portfolioImage: "./assets/portfolio-2.png",
            portfolioGithub: "https://github.com/shahwarkhan19/my-portfolio",
            portfolioLive: "https://shahwar-portfolio.netlify.app/",
        },
        {
            portfolioTitle: "Online Ecomerce Store Using ReactJs",
            portfolioImage: "./assets/portfolio-3.jpg",
            portfolioGithub: "https://github.com/shahwarkhan19/",
            portfolioLive: "https://talhastore.netlify.app/",
        },
        {
            portfolioTitle: "To Do Web App With Local Storage Using ReactJs ",
            portfolioImage: "./assets/portfolio-4.jpg",
            portfolioGithub: "https://github.com/shahwarkhan19/",
            portfolioLive: "https://to-do-app-019.netlify.app/",
        },
        {
            portfolioTitle: "Keep Notes App Using ReactJs",
            portfolioImage: "./assets/portfolio-5.jpg",
            portfolioGithub: "https://github.com/shahwarkhan19/",
            portfolioLive: "https://keep-notes-app-019.netlify.app/",
        },
        
    ],
    testimonial: [
        {
            tetimonialName: "Ahmad Zameer",
            testimonialPicture: "./assets/ahmad.jpeg",
            testimonialReview: "This developer is highly skilled and knowledgeable in their field. They consistently deliver high-quality and visually appealing projects that meet or exceed client expectations."
        },
        {
            tetimonialName: "Sonia Zaman",
            testimonialPicture: "./assets/sonia.jpg",
            testimonialReview: "This individual is a creative problem solver and always strives to find the best solution for their clients. Their attention to detail and ability to turn complex ideas into beautiful designs is truly impressive."
        },
        {
            tetimonialName: "M Ansar",
            testimonialPicture: "./assets/ansar.png",
            testimonialReview: "The developer is very professional and easy to work with. They have excellent communication skills and are always willing to go the extra mile to ensure client satisfaction."
        },
        {
            tetimonialName: "Osama Intikhab",
            testimonialPicture: "./assets/osama.png",
            testimonialReview: "This individual has a strong work ethic and is always willing to take on new challenges. They are able to work efficiently and effectively, delivering projects on time and within budget. Their expertise in both front-end development and Photoshop editing is a valuable asset to any project team."

            
        }
    ],
    messenger: "usman.mani.9615566",
    gmail: "Shahwarkhan092@gmail.com",
    whatsapp: "03445302464",
}
export default portfolioData